import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormGroup, FormControl, Validators} from '@angular/forms';

import {UserService} from '../shared/services/user.service';
import {SessionService} from '../shared/services/session.service';
import {Message} from 'primeng/primeng';
import {CommonDataService} from '../shared/services/common-data.service';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {BoundTextAst} from '@angular/compiler';
import {config} from 'process';
import {ConfigService} from '../config/config.service';
import {Alert} from 'selenium-webdriver';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    LoginData: FormGroup;
    error = false;
    errorMsg: string;
    msg: Message[] = [];
    submitted = false;
    cookieEnabled = true;
    hideUI = false;
    validEmail = false;


    constructor(private configService: ConfigService,
                private commonDataService: CommonDataService,
                private userService: UserService,
                private sessionService: SessionService,
                private router: Router) {
        this.LoginData = new FormGroup({
            'username': new FormControl('', Validators.required),
            'password': new FormControl('', Validators.required),
            'remembered': new FormControl(true)
        });


    }

    ngOnInit() {
    }

    validateEmail(email) {
        // tslint:disable-next-line:max-line-length
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    validatePassword() {
        if (!this.LoginData.get('password').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Password'});
        }
    }

    validateUsername() {
        if (!this.LoginData.get('username').valid) {
            this.msg.push({severity: 'error', detail: 'Please enter a value for Email'});
        } else {
            if (!this.validateEmail(this.LoginData.value.username)) {
                this.msg.push({severity: 'error', detail: 'Please enter a valid email address'});
            }
        }
    }

    submitUsername() {
        this.msg = [];

        const userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.LoginData.value));
        userData.username = userData.username.toLowerCase();

        this.hideUI = true;
        this.userService.userOtpLogin(userData)
            .subscribe(
                data => {
                    this.hideUI = false;
                    this.validEmail = true;
                },
                error => {
                    this.hideUI = false;
                    this.error = true;
                    if (error.parameterErrors !== undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else if (error.message.length !== 0) {
                        if (error['code'] && error.code === 58) {
                            this.msg.push({
                                severity: 'error',
                                detail: 'The email/password combination was incorrect. Please try again or contact an administrator.'
                            });
                        } else {
                            this.msg.push({severity: 'error', detail: error.message});
                        }
                    }
                }
            );
    }


    onSubmit() {
        this.msg = [];
        this.submitted = true;

        const userData = this.commonDataService.deleteEmptyObjectProperties(this.commonDataService.trimObjectData(this.LoginData.value));
        if (this.LoginData.valid === false || this.msg.length > 0) {
            return;
        }

        localStorage.removeItem('user_token_member');
        localStorage.removeItem('refresh_token_member');
        localStorage.removeItem('merchantId');

        userData.username = userData.username.toLowerCase();
        userData.password = encodeURIComponent(userData.password);
        // let remember = this.LoginData.value.remembered;
        // let tmprouter = this.router;
        this.hideUI = true;
        this.userService.userLogin(userData)
            .subscribe(
                data => {
                    let datatoken = JSON.stringify(data);
                    window.open(this.configService.appAdminURI + "?token=" + btoa(datatoken), "_self");
                },
                error => {
                    this.hideUI = false;
                    this.error = true;
                    if (error.parameterErrors !== undefined) {
                        for (let i = 0; i < error.parameterErrors.length; i++) {
                            this.msg.push({severity: 'error', detail: error.parameterErrors[i].message});
                        }
                    } else if (error.message.length !== 0) {
                        if (error['code'] && error.code === 58) {
                            this.msg.push({
                                severity: 'error',
                                detail: 'The email/password combination was incorrect. Please try again or contact an administrator.'
                            });
                        } else {
                            this.msg.push({severity: 'error', detail: error.message});
                        }
                    }
                }
            );
    }
}




// WEBPACK FOOTER //
// ./src/app/login/login.component.ts